import Vue from 'vue'
import Vuebar from 'vuebar'
import VueTouch from 'vue-touch';
import App from './App.vue'

Vue.use(Vuebar);
Vue.use(VueTouch);

const eventHub = new Vue();

Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.mixin({
    data: function () {
        return {
            eventHub: eventHub
        }
    }
});

window.addEventListener('touchstart', function() {
    document.getElementsByTagName('body')[0].classList.add('is-touch');
});

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js